import { Component, input, output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'table-datatable-edit-checkbox',
  templateUrl: './datatable-edit-checkbox.component.html',
  styleUrls: ['./datatable-edit-checkbox.component.scss'],
  imports: [MatCheckboxModule],
})
export class DatatableEditCheckboxComponent {
  value = input<boolean>();
  disabled = input<boolean>();

  checkBoxChange = output<boolean>();
}
